'use client'

import Cards from '@/ui/assets/components/cards.inline.svg'
import { cn } from '@/ui/utils/style'

interface CardWithDisclaimerProps {
  className?: string
  wrapperClassName?: string
}

export function CardWithDisclaimer({ className, wrapperClassName }: CardWithDisclaimerProps) {
  return (
    <div className={cn('flex flex-col', wrapperClassName)}>
      <Cards className={className} />
    </div>
  )
}
